import { withInstall } from '@vuesax-alpha/utils'
import Badge from './src/badge.vue'

export const VsBadge = withInstall(Badge)
export default VsBadge

export * from './src/badge'
